const mutations = {
    REFEREE_LOADING: (state) => {
        Vue.set(state, 'refereeStatus', 'loading');
    },
    SEASONS_SUCCESS: (state, data) => {
        state.refereeStatus = 'success';
        Vue.set(state, 'seasons', data);
        Vue.set(state, 'roster', []);
    },
    VENUES_SUCCESS: (state, data) => {
        state.refereeStatus = 'success';
        Vue.set(state, 'venues', data);
        Vue.set(state, 'roster', []);
    },
    ROSTER_SUCCESS: (state, data) => {
        state.refereeStatus = 'success';
        Vue.set(state, 'roster', data);
    },
    AVAIL_SUCCESS: (state, data) => {
        state.refereeStatus = 'success';
        Vue.set(state, 'availability', data);
    },
    POST_AVAIL_SUCCESS: (state, data) => {
        state.refereeStatus = 'success';
    },
    UPDATE_TO_UNAVAIL(state, data) {
        let unavail_arr = data.unavail_arr;

        state.availability.unavailability = unavail_arr;

        Vue.set(state, 'availability', state.availability);
    },
    ADD_TO_AVAIL(state, data) {
        let dayNum = data.dayNum;
        let time = data.time;

        if(state.availability.refGameTimes[dayNum]){
            if(state.availability.refGameTimes[dayNum].includes(time)){
                state.availability.refGameTimes[dayNum] = state.availability.refGameTimes[dayNum].filter(item => item !== time);
            } else {
                state.availability.refGameTimes[dayNum].push(time);
            }
        } else {
            state.availability.refGameTimes[dayNum] = [time];
        }

        Vue.set(state, 'availability', state.availability);
    },
    ROSTER_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.refereeStatus = 'error';
        state.refereeErrors.record(errors);
    },
    CLEAR_REFEREE_ERRORS: (state) => {
        state.refereeStatus = '';
        state.refereeErrors.clear();
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
